function Hero() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-secondary to-secondary/50 opacity-60" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <div className="space-y-4">
            <p className="text-primary tracking-widest uppercase opacity-80 font-sans">
              Bienvenue chez
            </p>
            <h1 className="text-5xl md:text-6xl font-serif text-text leading-tight">
              Les Jolies Choses
            </h1>
          </div>
          
          <p className="text-text/80 max-w-lg font-sans leading-relaxed">
            Votre dépôt-vente de mode féminine où l'élégance rencontre la durabilité. 
            Découvrez une sélection soignée de vêtements et accessoires de qualité pour 
            femmes qui cherchent style et authenticité.
          </p>

          <div className="flex gap-4 pt-4">
            <button
              onClick={() => scrollToSection("a-propos")}
              className="px-8 py-3 bg-primary text-white rounded-full hover:bg-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl font-sans"
            >
              Découvrir
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="px-8 py-3 bg-transparent border-2 border-primary text-primary rounded-full hover:bg-primary hover:text-white transition-all duration-300 font-sans"
            >
              Nous contacter
            </button>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/images/photo_hero_devanture.png"
              alt="Les Jolies Choses - Devanture de la boutique"
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-secondary rounded-full blur-3xl opacity-50" />
          <div className="absolute -top-6 -right-6 w-48 h-48 bg-secondary/50 rounded-full blur-3xl opacity-50" />
        </div>
      </div>
    </section>
  );
}

export default Hero;

